import React from 'react';
import { Create, useForm } from '@refinedev/antd';
import { useNavigation } from '@refinedev/core';
import { Form, Input, InputNumber, Switch, message } from 'antd';
import { LocalizedContentTabs, normalizeTranslations } from '../../components/LocalizedContentTabs';

const LANG_FIELDS = [
  { key: 'title', label: 'Title', placeholder: 'e.g. Beginner', required: true },
];

export const LevelCreate: React.FC = () => {
  const { formProps, onFinish } = useForm({ resource: 'levels' });
  const { push } = useNavigation();

  const handleSubmit = async (values: any) => {
    try {
      await onFinish({
        ...values,
        translations: normalizeTranslations(values.translations, LANG_FIELDS),
      });
      message.success('Level created');
      push('/levels');
    } catch (err: any) {
      message.error(err?.message || 'Failed to create level');
    }
  };

  return (
    <Create resource="levels" saveButtonProps={{ onClick: () => formProps.form?.submit() }}>
      <Form {...formProps} layout="vertical" onFinish={handleSubmit}>
        <LocalizedContentTabs fields={LANG_FIELDS} />
        <Form.Item label="Level Number" name="levelNumber" rules={[{ required: true }]}>
          <InputNumber style={{ width: '100%' }} min={1} />
        </Form.Item>
        <Form.Item label="Required XP" name="requiredXp" rules={[{ required: true }]}>
          <InputNumber style={{ width: '100%' }} min={0} />
        </Form.Item>
        <Form.Item label="Reward Coins" name="rewardCoins" initialValue={0}>
          <InputNumber style={{ width: '100%' }} min={0} />
        </Form.Item>
        <Form.Item label="Reward Badge ID" name="rewardBadgeId">
          <Input placeholder="Optional badge ID awarded on level-up" />
        </Form.Item>
        <Form.Item label="Icon URL" name="iconUrl">
          <Input placeholder="https://..." />
        </Form.Item>
        <Form.Item label="Active" name="isActive" valuePropName="checked" initialValue={true}>
          <Switch />
        </Form.Item>
      </Form>
    </Create>
  );
};
